import { DriveFolderUpload } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Badge from "@mui/material/Badge";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import noteIcon from "../../assets/svg/note-1-svgrepo-com 1.svg";
import key from "../../assets/svg/wrench (1) 1.svg";
import { newHost } from "../../pages/Categories/CategoryProfile";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";
import "./CheckingTools.css";

const CheckingTools = () => {
  const { user } = useSelector((state) => state.auth);

  const GET_ITEMS_URL =
    "https://estbn.com/EstbnNew/public/api/stuff/get-vehicle-equipments";

  const token = sessionStorage.getItem("token");
  const [vehicleInfo, setVehicleInfo] = useState(null);
  const [vehicleId, setVehicleId] = useState(null);
  const [equipmentChecks, setEquipmentChecks] = useState([]);
  const [noteValue, setNoteValue] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const fileInputRef = useRef(null);

  const loadData = async () => {
    try {
      const toolsRes = await axios.get(GET_ITEMS_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const toolsData = toolsRes.data.data.data || [];
      toolsData.find((item) => {
        const vehicleId = item.current_assignment?.vehicle_id;
        setVehicleId(vehicleId);
        return vehicleId;
      });
      let checksData = [];

      try {
        const checksRes = await axios.get(
          `${newHost}stuff/get-equipment-checks`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        checksData = checksRes.data.data.data || [];
      } catch (err) {
        checksData = [];
      }

      const checksMap = {};

      checksData.forEach((item) => {
        checksMap[item.equipment_id] = {
          status: item.status,
          notes: item.notes || "",
          image_path: item.image_url || null,
        };
      });

      const merged = toolsData.map((tool) => ({
        equipment_id: tool.id,
        name: tool.internal_serial_number,
        status: checksMap[tool.id]?.status || "",
        notes: checksMap[tool.id]?.notes || "",
        file: null, 
        image_path: checksMap[tool.id]?.image_path || null, 
        synced: Boolean(checksMap[tool.id]),
      }));

      setEquipmentChecks(merged);
      const isAllChecked = merged.every((item) => item.status !== "");

      setIsChecked(isAllChecked);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadData();
  }, []);
    useEffect(() => {
      if (user) {
        setVehicleInfo(user.stuff?.current_assignments[0]);
      }
    }, [user]);
  

  const handleStatusChange = (id, value) => {
    setEquipmentChecks((prev) =>
      prev.map((item) =>
        item.equipment_id == id
          ? {
              ...item,
              status: value,
              notes: value === "functional" ? "" : item.notes,
              synced: false,
            }
          : item,
      ),
    );
  };

  const handleSave = async () => {
    const formData = new FormData();

    equipmentChecks.forEach((item, index) => {
      formData.append(
        `equipment_checks[${index}][equipment_id]`,
        item.equipment_id,
      );

      formData.append(`equipment_checks[${index}][status]`, item.status);
      if (item.status == "not_functional") {
        formData.append(`equipment_checks[${index}][notes]`, item.notes || "");
        if (item.file) {
          formData.append(`equipment_checks[${index}][image]`, item.file);
        } else if (item.image_path) {
          formData.append(
            `equipment_checks[${index}][image_path]`,
            item.image_path,
          );
        }
      }
    });

    try {
      const response = await axios.post(
        `${newHost}stuff/store-equipments-check/${vehicleId}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      toast.success(response.data.message);

      setEquipmentChecks((prev) =>
        prev.map((item) => ({ ...item, synced: true })),
      );

      const isAllChecked = equipmentChecks.every(
        (item) =>
          item.status === "functional" || item.status === "not_functional",
      );

      setIsChecked(isAllChecked);
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [currentTool, setCurrentTool] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isViewOnly, setIsViewOnly] = useState(false);

  const openModal = (tool) => {
    if (tool.status !== "not_functional") return;

    setIsViewOnly(Boolean(tool.synced));

    setCurrentTool(tool);
    setNoteValue(tool.notes || "");
    setSelectedFile(tool.file || null);

    if (tool.file) {
      setImagePreview(URL.createObjectURL(tool.file));
    } else if (tool.image_path) {
      setImagePreview(`${newImageUrl}${tool.image_path}`);
    } else {
      setImagePreview(null);
    }

    setShowModal(true);
  };

  const FileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
      setSelectedFile(file);
      setCurrentTool((prev) => (prev ? { ...prev, image_path: null } : prev));
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveImage = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setSelectedFile(null);
    setImagePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
    setCurrentTool((prev) => (prev ? { ...prev, image_path: null } : prev));
  };

  const saveNote = (note) => {
    setEquipmentChecks((prev) =>
      prev.map((item) =>
        item.equipment_id == currentTool.equipment_id
          ? {
              ...item,
              notes: note,
              file: selectedFile,
              image_path: selectedFile ? null : currentTool?.image_path || null,
            }
          : item,
      ),
    );
    setShowModal(false);
  };

  const boxStyle = {
    width: 25,
    height: 25,
    border: "2px solid #D1D5DB",
    borderRadius: 6,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const totalTools = equipmentChecks.filter(
    (item) => item.status === "functional" || item.status === "not_functional",
  ).length;
  const healthyCount = equipmentChecks.filter(
    (s) => s.status == "functional",
  ).length;
  const brokenCount = equipmentChecks.filter(
    (s) => s.status === "not_functional",
  ).length;

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        dialogClassName="custom-modal-campaigns-width"
      >
        <Modal.Header className="d-flex align-items-center">
          <Modal.Title
            style={{ direction: "rtl" }}
            className="fw-bold fs-5 text-center m-0"
          >
            ملاحظات و مرفقات علي الادوات في السيارة
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-2" style={{ direction: "rtl" }}>
          <div className="">
            <h6>
              {isViewOnly
                ? "الملاحظات المسجلة"
                : "اكتب ملاحظة أو ارفع صورة للجزء في حالة وجود مشكله"}
            </h6>
            {isViewOnly ? (
              <div
                style={{
                  padding: 20,
                  borderRadius: 10,
                  border: "solid 2px #D8D8D8",
                  backgroundColor: "#F8F8F8",
                  minHeight: 90,
                }}
                className="w-100"
              >
                {noteValue || (
                  <span className="text-muted">لا توجد ملاحظات</span>
                )}
              </div>
            ) : (
              <textarea
                value={noteValue}
                onChange={(e) => setNoteValue(e.target.value)}
                style={{
                  padding: 20,
                  borderRadius: 10,
                  border: "solid 2px #D8D8D8",
                }}
                rows={4}
                className="w-100"
                placeholder="اضف ملاحظاتك"
              ></textarea>
            )}
          </div>

          <div className="my-3">
            <p>{isViewOnly ? "المرفقات" : "اضافة مرفقات"}</p>

            {imagePreview ? (
              isViewOnly ? (
                <img
                  src={imagePreview}
                  alt="preview"
                  style={{
                    width: "100%",
                    height: 150,
                    objectFit: "fill",
                    borderRadius: 10,
                  }}
                />
              ) : (
                <div
                  className="position-relative w-100"
                  style={{ border: "2px dashed #C6C6C6", borderRadius: 10 }}
                >
                  <Badge
                    overlap="rectangular"
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    sx={{ width: "100%", display: "block" }}
                    badgeContent={
                      <IconButton
                        size="small"
                        onClick={handleRemoveImage}
                        sx={{
                          backgroundColor: "#fff",
                          boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                          padding: "3px",
                          "&:hover": { backgroundColor: "#f2f2f2" },
                        }}
                      >
                        <CloseIcon sx={{ fontSize: 16, color: "#A80101" }} />
                      </IconButton>
                    }
                  >
                    <img
                      src={imagePreview}
                      alt="preview"
                      style={{
                        width: "100%",
                        height: 150,
                        objectFit: "fill",
                        borderRadius: 10,
                        display: "block",
                      }}
                    />
                  </Badge>
                </div>
              )
            ) : isViewOnly ? (
              <p className="text-muted mb-0">لا توجد صورة مرفقة</p>
            ) : (
              <label className="cursor w-100" htmlFor="upload-file">
                <div
                  style={{ border: "2px dashed #C6C6C6" }}
                  className="p-4 w-100 rounded-3 d-flex justify-content-center align-items-center"
                >
                  <div className="text-center">
                    <DriveFolderUpload
                      sx={{ fontSize: "50px", color: "#535353" }}
                    />
                    <p style={{ color: "#535353", margin: 0 }}>اضف ملف </p>
                  </div>
                </div>
              </label>
            )}

            {!isViewOnly && (
              <input
                type="file"
                accept="image/*"
                onChange={FileChange}
                ref={fileInputRef}
                hidden
                id="upload-file"
              />
            )}
          </div>

          {!isViewOnly && (
            <div className="d-flex justify-content-center align-items-center my-5 gap-4">
              <button
                onClick={() => saveNote(noteValue)}
                className="btn btn-dark px-4"
              >
                حفظ الفحص
              </button>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <div className="py-4 px-3 px-md-5">
        <div
          className="p-4 mb-4 d-flex justify-content-between align-items-center"
          dir="rtl"
        >
          <div className="text-end">
            <h5 className="fw-bold mb-2">{`مراجعة الادوات على سيارة ${vehicleInfo?.id}#`}</h5>
            <p className="text-muted small mb-0 lh-base">
              راجع حالة الأدوات التي أقر بها الفني وتأكد من سلامتها.
            </p>
          </div>
          <div className="text-center">
            <img src={key} alt="key" width="60" />
          </div>
        </div>

        <div className="row g-4">
          <div className="col-lg-7 order-lg-2">
            <div className="p-4">
              <div
                className="d-flex justify-content-start gap-3 mb-3 px-2"
                dir="rtl"
              >
                <span className="small fw-bold text-muted">سليم</span>
                <span className="small fw-bold text-muted">عطل</span>
              </div>
              <div className="items-list d-flex flex-column gap-2" dir="rtl">
                {equipmentChecks.map((tool) => {
                  const hasAttachment =
                    tool?.notes || tool?.file || tool?.image_path;
                  return (
                    <div
                      key={tool.equipment_id}
                      className="d-flex justify-content-between align-items-center border-bottom py-3 "
                    >
                      <div className="d-flex gap-2 align-items-center">
                        <Checkbox
                          checked={tool.status === "functional"}
                          onChange={() =>
                            handleStatusChange(tool.equipment_id, "functional")
                          }
                          icon={<div style={boxStyle} />}
                          checkedIcon={
                            <div
                              style={{
                                ...boxStyle,
                                backgroundColor: "#3FBEAC",
                              }}
                            >
                              <CheckIcon
                                style={{ color: "#fff", fontSize: 18 }}
                              />
                            </div>
                          }
                        />

                        <Checkbox
                          checked={tool.status === "not_functional"}
                          onChange={() =>
                            handleStatusChange(
                              tool.equipment_id,
                              "not_functional",
                            )
                          }
                          icon={<div style={boxStyle} />}
                          checkedIcon={
                            <div
                              style={{
                                ...boxStyle,
                                backgroundColor: "#A80101",
                              }}
                            >
                              <CloseIcon
                                style={{ color: "#fff", fontSize: 18 }}
                              />
                            </div>
                          }
                        />
                        <div className="">
                          <p className="m-0">{tool.name}</p>
                        </div>
                      </div>

                      <Badge
                        color="error"
                        variant="dot"
                        overlap="circular"
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        invisible={!hasAttachment}
                      >
                        <img
                          src={noteIcon}
                          alt="note"
                          onClick={() => openModal(tool)}
                          style={{ width: "24px", cursor: "pointer" }}
                        />
                      </Badge>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="col-lg-5 order-lg-1">
            <div className="ct-info-card p-4 h-100">
              <div className="d-flex justify-content-between align-items-start mb-4">
                <span className="text-muted small">
                  تم فحص {totalTools} من {equipmentChecks.length} اداة
                </span>
                <h5 className="fw-bold">ملخص الفحص</h5>
              </div>
              <div className="d-flex flex-column align-items-end gap-3">
                <div className="d-flex align-items-center gap-2">
                  <span className="fw-bold">{healthyCount} سليم</span>
                  <div className="ct-summary-icon healthy">
                    <Checkbox
                      checked={equipmentChecks.filter(
                        (s) => s.status == "functional",
                      )}
                      icon={<div style={boxStyle} />}
                      checkedIcon={
                        <div
                          style={{ ...boxStyle, backgroundColor: "#3FBEAC" }}
                        >
                          <CheckIcon style={{ color: "#fff", fontSize: 18 }} />
                        </div>
                      }
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="fw-bold">{brokenCount} به عطل</span>
                  <div className="ct-summary-icon broken">
                    <Checkbox
                      checked={equipmentChecks.filter(
                        (s) => s.status == "not_functional",
                      )}
                      icon={<div style={boxStyle} />}
                      checkedIcon={
                        <div
                          style={{ ...boxStyle, backgroundColor: "#A80101" }}
                        >
                          <CloseIcon style={{ color: "#fff", fontSize: 18 }} />
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!isChecked &&
          <div className="text-center mt-5">
            <button
              className="btn btn-dark ct-save-btn px-5 py-2"
              onClick={handleSave}
            >
              حفظ الفحص
            </button>
          </div>
        }
      </div>
    </>
  );
};

export default CheckingTools;
